<header class="recruiter-nav__header" [ngClass]="{'recruiter-nav__header--scrolled': isScrolled}">
  <!-- Navbar -->
  <div class="recruiter-nav__wrapper" [ngClass]="{'recruiter-nav__wrapper--scrolled': isScrolled}">
    <nav class="recruiter-nav__navbar" [ngClass]="{'recruiter-nav__navbar--scrolled': isScrolled}">
      <!-- Brand (Logo + Mobile Candidate Btn) -->
      <div class="recruiter-nav__brand">
        <a routerLink="/" class="recruiter-nav__logo-link cursor-pointer">
          <img alt="BeExpert.ai" class="recruiter-nav__logo-img recruiter-nav__logo-img--desktop" src="/assets/images/BeExpert-logo%20(2).svg" />
          <img alt="BeExpert.ai" class="recruiter-nav__logo-img recruiter-nav__logo-img--mobile" src="/assets/images/beExpert-logo-new.png" />
        </a>
        <div class="recruiter-nav__mobile-buttons">
          <button class="recruiter-nav__login-btn recruiter-nav__login-btn--mobile" routerLink="/company-auth">
            Login
          </button>
          <button class="recruiter-nav__candidate-btn recruiter-nav__candidate-btn--mobile" routerLink="/">
            For Candidates
          </button>
        </div>
      </div>

      <!-- Links (Desktop) -->
      <div class="recruiter-nav__links">
        <button class="recruiter-nav__link" (click)="scrollTo('app-recruiter-hiring-process')">Hiring</button>
        <button class="recruiter-nav__link" (click)="scrollTo('app-recruiter-features')">AI Features</button>
        <button class="recruiter-nav__link" (click)="scrollTo('app-recruiter-testimonials')">Testimonials</button>
        <!-- <button class="recruiter-nav__link" (click)="scrollTo('app-recruiter-cta')">Pricing</button> Pricing isn't currently available, linking to CTA -->
      </div>

      <!-- Actions (Desktop) -->
      <div class="recruiter-nav__actions">
        <button class="recruiter-nav__login-btn" routerLink="/company-auth">Login</button>
        <button class="recruiter-nav__candidate-btn" routerLink="/">
          For Candidates
          <svg aria-hidden="true" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-linecap="round"
            stroke-linejoin="round" stroke-width="2" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12h14"></path>
            <path d="m12 5 7 7-7 7"></path>
          </svg>
        </button>
      </div>

      <!-- Mobile Toggle -->
      <button (click)="toggleMobileMenu()" class="recruiter-nav__mobile-toggle">
        <svg *ngIf="!isMobileMenuOpen" aria-hidden="true" class="recruiter-nav__icon" fill="none" height="24"
          stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
          width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 12h16"></path>
          <path d="M4 18h16"></path>
          <path d="M4 6h16"></path>
        </svg>
        <svg *ngIf="isMobileMenuOpen" aria-hidden="true" class="recruiter-nav__icon" fill="none" height="24"
          stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24"
          width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M18 6 6 18"></path>
          <path d="m6 6 12 12"></path>
        </svg>
      </button>

      <!-- Mobile Menu -->
      <div *ngIf="isMobileMenuOpen" class="recruiter-nav__mobile-menu">
        <div class="recruiter-nav__mobile-links">
          <button class="recruiter-nav__mobile-link" (click)="scrollTo('app-recruiter-hiring-process')">Hiring</button>
          <button class="recruiter-nav__mobile-link" (click)="scrollTo('app-recruiter-features')">AI Features</button>
          <button class="recruiter-nav__mobile-link"
            (click)="scrollTo('app-recruiter-testimonials')">Testimonials</button>
          <!-- <button class="recruiter-nav__mobile-link" (click)="scrollTo('app-recruiter-cta')">Pricing</button> -->
        </div>
        <div class="recruiter-nav__mobile-actions">
          <button class="recruiter-nav__mobile-login-btn" routerLink="/company-auth" (click)="toggleMobileMenu()">Login</button>
          <button class="recruiter-nav__mobile-candidate-btn" routerLink="/" (click)="toggleMobileMenu()">For
            Candidates</button>
        </div>
      </div>
    </nav>
  </div>
</header>